export const SCAN_READ_NOT_ALLOWED_REGEXP = /Scan status not allowed for read:\s*\[?(PREPARED|PROCESSED)\]?/;
export const BLOCKED_STATUS_TEXT_MAP: Record<string, { title: string; description?: string }> = {
  PROCESSED: {
    title: 'This candidate has already been merged.',
    description: 'This duplicate merge has already been processed and cannot be re-run.',
  },
  PREPARED: {
    title: 'Merge is temporarily unavailable',
    description: 'This candidate is currently being processed. Please try again later.',
  },
};
